import { useEffect } from 'react';
import { T } from '../lib/design-tokens';

interface ToastProps {
  message: string;
  onDismiss: () => void;
}

export function Toast({ message, onDismiss }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 3500);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 28,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '14px 28px',
        borderRadius: 14,
        background: T.surface,
        border: `1px solid ${T.goldDim}`,
        color: T.gold,
        fontFamily: T.mono,
        fontSize: 12,
        fontWeight: 600,
        boxShadow: `0 12px 40px rgba(0,0,0,0.4), 0 0 20px ${T.goldGlow}`,
        animation: 'toastIn 0.4s cubic-bezier(0.4,0,0.2,1)',
        zIndex: 10000,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
      }}
    >
      {message}
    </div>
  );
}
